/**
 * The Wellbeing surface: one hub and a page per tool, like Mindspace.
 * Real URLs, so the back button works and the timer pill can link straight
 * to the Focus page.
 */
export const WELLBEING_PATHS = {
  hub: '/wellbeing',
  focus: '/wellbeing/focus',
  breathe: '/wellbeing/breathe',
  worry: '/wellbeing/worry',
} as const;

export type WellbeingTool = 'focus' | 'breathe' | 'worry';
